import { createAsyncAction } from 'services/actionConfigs';
import { PREFIX_ACTIONS } from './constants';
import { ICategoryItemData } from 'services/shop/types/categories';
import { IDepositTransactionResData } from './types/deposit';

const getGetDetailAppointment = createAsyncAction<{ aptId: string, shopId: string }>(PREFIX_ACTIONS + 'getGetDetailAppointment');

const getServicesByStaff = createAsyncAction<string, ICategoryItemData[]>(PREFIX_ACTIONS + 'getServicesByStaff');

const getDepositTransactionData = createAsyncAction<string, IDepositTransactionResData>(PREFIX_ACTIONS + 'getDepositTransactionData');

const aptActions = {
  getGetDetailAppointment,
  getServicesByStaff,
  getDepositTransactionData,
};

export default aptActions;
